import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {EventManagerWithAsync} from '@fantasmagames/core/src/events/EventManagerWithAsync';
import {Device} from '@fantasmagames/core/src/device/Device';
import {ResolutionManager} from '@fantasmagames/core/src/screen/ResolutionManager';
import {HTMLPageComponent} from '@fantasmagames/core/src/html/HTMLPageComponent';
import {I2dLimits} from '@fantasmagames/slot/src/modules/popupmenus/Scrollbar';

export interface INamedHTMLComponentMap {
	[name: string]: HTMLPageComponent;
}

export class HTMLUtils {
	protected resolutionManager: ResolutionManager;
	protected resources: ResourcesLoader;
	protected device: Device;
	protected eventManager: EventManagerWithAsync;

	protected _htmlComponents: INamedHTMLComponentMap = {};

	constructor(resourceloader: ResourcesLoader, device: Device, resolutionManager: ResolutionManager) {
		this.resources = resourceloader;
		this.device = device;
		this.resolutionManager = resolutionManager;
	}

	public makeHtml(
		name: string,
		limits: I2dLimits = {
			maxX: this.resolutionManager.resolution.width,
			maxY: this.resolutionManager.resolution.height,
			minX: 0,
			minY: 0,
		},
		htmlPath: string = '/HMTL',
	): HTMLPageComponent {
		this.removeHtml(name);

		const htmlPage: HTMLPageComponent = new HTMLPageComponent(this.resources, this.device, this.resolutionManager);

		htmlPage.init(limits, '/HTML/', `fantasmaHTMLComponent_${name}`);
		this.addHtml(name, htmlPage);

		return htmlPage;
	}

	public show(name: string): void {
		if (this.hasHtml(name)) {
			this.getHtml(name).show();
		}
	}

	public makeHtmlButton(text: string, onClick: Function): HTMLElement {
		const button = document.createElement('button');
		button.style.position = 'absolute';
		button.style.top = '10px';
		button.style.right = '10px';
		button.style.width = '3em';
		button.style.height = '3em';
		button.style.pointerEvents = 'all';
		button.textContent = text;
		button.onclick = onClick as any;

		return button;
	}

	public hasHtml(name: string): boolean {
		return !!this._htmlComponents[name];
	}

	public getHtml(name: string): HTMLPageComponent {
		return this._htmlComponents[name] ? this._htmlComponents[name] : null;
	}

	public addHtml(name: string, html: HTMLPageComponent): void {
		this._htmlComponents[name] = html;
	}

	public removeHtml(name: string): void {
		if (this._htmlComponents[name]) {
			this._htmlComponents[name].destroy();
			this._htmlComponents[name] = null;
		}
	}

	public resizeItems(): void {
		for (const item in this._htmlComponents) {
			if (this._htmlComponents.hasOwnProperty(item)) {
				const html = this._htmlComponents[item];
				if (html) {
					html.resizeHTML();
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/html/HTMLUtils.ts